import styled from "styled-components";
import ToastContainer from "./component";
import { colors } from "utils";

export default styled(ToastContainer)`
  position: fixed;
  bottom: 16px;
  right: 16px;
`;
